module.exports = __webpack_public_path__ + "img/img12.22873578.png";